'use client';

import React from 'react';
import MainBodyToReact from '../MainBodyToReact';
import { Document } from '@contentful/rich-text-types';
import { useContentfulInspectorMode } from '@contentful/live-preview/react';

interface ITextCardBlockProps {
    item: {
        title: string;
        description: Document | undefined;
        key: string;
    };
    id: string;
}

const TextCardBlock: React.FC<ITextCardBlockProps> = ({ item, id }) => {
    const inspectorProps = useContentfulInspectorMode({ entryId: id });
    return (
        <div className="tw-w-full tw-bg-white tw-rounded-lg tw-px-[15px] tw-py-[15px] sm:tw-max-w-[48%] lg:tw-max-w-[24%]">
            <div className="tw-pt-[20px]">
                <h2
                    className="lg:tw-text-[16px] md:tw-text-[14px] tw-text-[16px] tw-leading-[27px] tw-font-gotham-bold tw-text-[#003865] tw-pb-[10px]"
                    {...inspectorProps({
                        fieldId: 'title',
                    })}
                >
                    {item.title}
                </h2>
                {item.description && (
                    <MainBodyToReact
                        body={item.description}
                        classes={{
                            p: 'tw-text-[14px] tw-font-gotham-book tw-text-[#4b4f54] tw-leading-[22px] !tw-pb-0',
                        }}
                        fieldId="content"
                        id={id}
                    />
                )}
            </div>
        </div>
    );
};

export default TextCardBlock;
